import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import { useNavigation } from '@react-navigation/native';

const ReturnOrder = (props) => {
  const { detailData, route, width } = props;

  const navigation = useNavigation();

  const doReturn = () => {
    let goBackKey = '';
    if (route?.params?.customerId && route?.params?.titleScreen && route?.key) {
      goBackKey = route.key;
    }
    navigation.navigate('ReturnOrderNavigator', {
      screen: 'ReturnOrderFormScreen',
      params: {
        titleScreen: detailData?.reference_code || '-',
        name: detailData?.customer?.name || '-',
        id: detailData?._id,
        data: detailData,
        isSales: true,
        go_back_key: goBackKey,
      },
    });
  };

  return (
    <View style={[styles.search, { width: width || 100 }]}>
      <TouchableOpacity
        activeOpacity={0.6}
        style={styles.searchBtn}
        onPress={() => doReturn()}>
        <SociollaText type="medium" style={styles.searchBtnText}>
          Return Order
        </SociollaText>
      </TouchableOpacity>
    </View>
  );
};

ReturnOrder.propTypes = {
  detailData: PropTypes.shape({
    reference_code: PropTypes.string,
    customer: PropTypes.shape({
      name: PropTypes.string,
    }),
    _id: PropTypes.string,
  }),
  route: PropTypes.shape({
    params: PropTypes.shape({
      customerId: PropTypes.string,
      titleScreen: PropTypes.string,
    }),
    key: PropTypes.string,
  }),
  width: PropTypes.number,
};

/* eslint-disable react-native/no-color-literals */
const styles = StyleSheet.create({
  search: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchBtn: {
    width: 100,
    height: 36,
    borderRadius: 10,
    backgroundColor: '#ebecf0',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
  },
  searchBtnText: {
    fontSize: 12,
    color: Colors.black,
  },
});

export default React.memo(ReturnOrder, (prev, next) => prev === next);
